<template>
  <!-- 版心内容 -->
  <div class="centerBox">
    <!-- 筛选框 -->
    <div class="InsuranceSelect">
      <el-row>
        <el-col :span="20" :offset="0" type="flex">
          <el-select
            style="margin-right: 10px"
            clearable
            @change="selInLists"
            v-model="selFromData.insuranceStatus"
            placeholder="请选择保单状态"
            size="medium"
          >
            <el-option
              v-for="item in insureStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>

          <el-input
            @change="selInLists"
            placeholder="请输入保单号搜索"
            v-model="selFromData.policyNo"
            clearable
            size="medium"
            maxlength="30"
          >
          </el-input>
        </el-col>
        <el-col :span="2" :offset="2">
          <el-button
            type="primary"
            size="small"
            @click="buyInsure"
            class="button14"
            >申请投保</el-button
          >
        </el-col>
      </el-row>
      <!-- 分割线 -->
      <el-divider></el-divider>
    </div>

    <!-- 表格 列表组件  有操作按钮 -->

    <table-list
      ref="tabList"
      class="tablelist"
      :list="list"
      :isShow="isShow"
      :loading="loading"
    />

    <!-- 分页 -->
    <pagiation
      :total="total"
      :pageSize="pageSize"
      :pageNo="pageNo"
      @currentChange="currentChange"
      :pagisShow="isShow"
      v-if="isShow"
    />

    <fu-box />
  </div>
</template>

<script>
import TableList from "./TableList.vue";
import { ruralInsurance } from "@/api/request/snkd.produce";
import FuBox from "../compoments/ruralBox.vue";
import Pagiation from "@/components/Pagiation.vue";
import sameIn from "@/mixins/ruralListsdetails.js";

export default {
  components: { TableList, FuBox, Pagiation },
  name: "InsuranceList",
  mixins: [sameIn],

  data() {
    return {
      // 搜索是否有数据  分页是否显示 -- 是否显示无数图片
      isShow: true,
      loading: true,
      // 状态
      insureStatus: [
        { label: "全部状态", value: -1 },
        { label: "待缴费", value: 2 },
        { label: "生效中", value: 4 },
      ],

      list: [],

      // 获取保单列表参数
      selFromData: {
        // 状态
        insuranceStatus: null,
        // 保单号
        policyNo: null,
      },
    };
  },
  created() {
    this.getRuralInLists();
  },

  methods: {
    // 筛选
    selInLists() {
      this.pageNo = 1;
      this.getRuralInLists();
    },

    // 获取保单列表
    async getRuralInLists() {
      this.loading = true;
      const { respCode, obj } = await ruralInsurance.getRuralList({
        companyId: this.companyId,
        farmId: this.farmId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        insuranceStatus:
          this.selFromData.insuranceStatus == -1
            ? ""
            : this.selFromData.insuranceStatus,
        insuranceId: this.selFromData.policyNo,
        itemCode: "",
      });
      if (respCode === 0) {
        this.list = obj;
        this.total = obj.length;
        if (this.list.length) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.centerBox {
  background-color: #fff;
  min-height: calc(100vh - 80px);
  // height: 100%;
  .tablelist {
    padding: 0 30px 30px 30px;
    min-height: calc(100vh - 360px) !important;
  }
}

::v-deep .el-table {
  height: 100%;
  .el-table__body-wrapper {
    overflow: hidden;
    position: relative;
    height: calc(100% - 80px);
  }
}

.InsuranceSelect {
  padding: 30px 30px 0;
}

::v-deep .el-select .el-input__inner {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-col-20 {
  // display: flex;
  // justify-content: space-between;
}
::v-deep .el-row {
  margin-left: 0 !important;
}
.el-select {
  width: 224px;
}
.el-input--suffix {
  width: 224px;
}
.el-button--small {
  width: 92px;
  height: 40px;
}
::v-deep .el-input--medium .el-input__inner {
  height: 40px;
}
</style>
